// ลำดับโซนของรูป : _F ขึ้นก่อน ตามด้วย _B ส่วนไฟล์ที่ไม่มีตัวบอกโซนต่อท้ายสุด
const ZONE_ORDER = ["F", "B"];

/** ดึงชื่อไฟล์จาก path เช่น {barcode}/{matcode}/packshot/xxx_1_F.png -> xxx_1_F.png */
export const getFileNameFromPath = (path?: string | null): string => {
  if (!path) return "";

  const segments = `${path}`.split("/");
  return segments[segments.length - 1];
};

/**
 * หาโซนจากชื่อไฟล์ โดยดู segment สุดท้ายหลังตัดนามสกุล
 * xxx_F.png / xxx_1_F.png -> โซน F, xxx_B.png -> โซน B
 * ชื่อที่ไม่ลงท้ายด้วย _F / _B (เช่น file-041-0290.png) -> ไม่มีโซน ไปต่อท้าย
 */
export const getImageZoneIndex = (fileName?: string | null): number => {
  if (!fileName) return ZONE_ORDER.length;

  const segments = `${fileName}`
    .replace(/\.[^.]+$/, "") // ตัดนามสกุล
    .toUpperCase()
    .split("_"); // matcode / barcode ใช้ "-" จึงไม่ชนกับการแยกโซน

  const zoneIndex = ZONE_ORDER.indexOf(segments[segments.length - 1]);

  return zoneIndex === -1 ? ZONE_ORDER.length : zoneIndex;
};

/**
 * เรียงชื่อไฟล์รูป
 * 1. ถ้ามี _F / _B : F มาก่อน B แล้วค่อยเป็นไฟล์ที่ไม่มีตัวบอกโซน
 * 2. ในกลุ่มเดียวกัน (รวมกรณีไม่มี _F/_B เลย) : เรียงชื่อไฟล์ asc แบบ 1 2 5 10 ไม่ใช่ 1 10 2 5
 */
export const compareImageFileName = (
  nameA?: string | null,
  nameB?: string | null
): number => {
  const zoneA = getImageZoneIndex(nameA);
  const zoneB = getImageZoneIndex(nameB);

  if (zoneA !== zoneB) {
    return zoneA - zoneB;
  }

  return `${nameA}`.localeCompare(`${nameB}`, undefined, {
    numeric: true,
    sensitivity: "base",
  });
};
